import type { ComponentProps } from 'styled-system/types'

import { ark } from '@ark-ui/react/factory'
import { styled } from 'styled-system/jsx'
import { input } from 'styled-system/recipes'

export type InputProps = ComponentProps<typeof Input>
export const Input = styled(ark.input, input)
